import { Injectable } from '@angular/core';
import { UserDashService } from 'contact-dash';
import { Observable, Subject } from 'rxjs';
import { FilterParams, IUserAccountModel, UserGroupLinkModel } from 'starbase-launcher';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';
import { UserGroupModel_ext } from '../models/lu_usergroup';
import { catchError, mergeMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserDataService extends UserDashService {
  protected _getPasswordScoreUri = '/api/User/CheckPasswordScore/';
  protected _getUserAccountDataUri = '/api/User';
  protected _getMyAccountUri = '/api/User/GetMyAccount';
  protected _getUserGroupsUri = '/api/LU_UserGroupModel';
  protected _getActiveUsersUri = '/api/User/GetActiveUsers';
  protected _postUserGroupLinksUri = '/api/UserGroupLinkModels';
  protected _deleteUserGroupLinksUri = '/api/UserGroupLinkModels/';
  protected _resetUserLockoutUri = '/api/User/ResetUserLockout?id=';
  protected _changePasswordUri = '/api/User/ChangePassword';
  protected _changeDisplayNameUri = '/api/User/ChangeDisplayName';
  protected _passwordScoreUri = '/api/User/CheckPasswordScore?pwd=';
  protected _getUsernameAllowedUri = '/api/User/GetUserNameAllowed?user=';
  protected _verifyRecaptchaUri = '/api/User/VerifyRecaptcha';
  protected _passwordResetRequestUri = '/api/User/RAPasswordResetRequest?user=';
  protected _confirmPwdResetUri = '/api/User/ConfirmResetPassword';
  protected _signupNewAccountUri = '/api/User/SignupNewAccount';
  protected _sendAttemptedUpgradeEmail = '/api/User/SendAttemptedUpgradeEmail';
  protected _sendAttemptedCancellationEmail = '/api/User/SendAttemptedCancellationEmail';
  protected _staleDataTimeout = 1500;
  protected _getOneUri = '/api/User/';
  protected _getAllUri = '';
  protected _postUri = '/api/User';
  protected _putUri = '/api/User/EditUserAccountModel?id=';
  protected _deleteUri = '/api/User/';
  protected _broadSearchUri = '';
  private resendConfirmationEmailUri = '/api/User/ResendConfirmationEmail';

  private _deleteSubscriberUserGroupTrigger$: Subject<string | number>;

  constructor(_http: HttpClient, _webApi: WebApiService) {
    super(_http, _webApi);
    this._deleteSubscriberUserGroupTrigger$ = new Subject<string | number>();
   }

  public get deleteSubscriberUserGroupTrigger$(): Subject<string | number> {
    return this._deleteSubscriberUserGroupTrigger$;
  }
  public resendConfirmationEmail(user: string): Observable<any> {
    return this.postRequisiteData(this.resendConfirmationEmailUri, `"${user}"`);
  }

  getDataByFilterParamsBroadSearch(url: string,
    filterParams: FilterParams<IUserAccountModel>): Observable<FilterParams<IUserAccountModel>> {
    throw new Error('Method not implemented.');
  }

  public deleteData(url: string, id: string | number): Observable<any> {
    if (url === this.DelUserGroupLinksUri) {
      return this.getRequisiteData<UserGroupLinkModel>(this.PostUserGroupLinksUri + '/', id)
        .pipe(mergeMap(
          (ug) => {
            if ((ug.userGroup as UserGroupModel_ext).requiresSubscription) {
              this.deleteSubscriberUserGroupTrigger$.next(id);
              return this.deleteSubscriberUserGroupTrigger$;
            } else {
              return this.deleteSubscriberUserGroupLink(id);
            }
          }
      ));
    } else {
      return super.deleteData(url, id);
    }
  }

  public deleteSubscriberUserGroupLink(id: string | number): Observable<any> {
    return super.deleteData(this.DelUserGroupLinksUri, id);
  }

  public getActiveUsers(): Observable<number> {
    return this.getRequisiteData<number>(this._getActiveUsersUri);
  }

  public sendAttemptedUpgradeEmail() {
    return this.getRequisiteData(this._sendAttemptedUpgradeEmail);
  }

  public sendAttemptedCancellationEmail() {
    return this.getRequisiteData(this._sendAttemptedCancellationEmail);
  }

  public verifyRecaptcha(token: string) {
    return this.postRequisiteData<boolean | string>(this._verifyRecaptchaUri, '"' + token + '"');
  }
}
